import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { Box, SxProps } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import IconButton from '@mui/material/IconButton';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { PickersDay } from '@mui/x-date-pickers';
import { SubDateRangePickerProps } from '../../DataRangePicker/DataRangePicker';
import { CircularProgress } from '@mui/material';
import { Backdrop } from '@mui/material';
import { DateTime } from 'luxon';

export const DesktopDateRangePicker = (props: SubDateRangePickerProps): JSX.Element => {
    const {
        onMonthDecrease,
        onMonthIncrease,
        onRangePositionChange,
        startDate,
        endDate,
        startPeriod,
        endPeriod,
        loading = false,
        sxCalendar,
        slots,
        slotProps
    } = props;

    const onMonthDecreaseHandler = (date: any) => {
        if (onMonthDecrease === undefined) {
            return;
        }
        
        onMonthDecrease(date);
    }

    const onMonthIncreaseHandler = (date: any) => {
        if (onMonthIncrease === undefined) {
            return;
        }

        onMonthIncrease(date);
    }

    const Day = slots?.day ?? PickersDay;

    const headerStyle: SxProps = {
        fontSize: '20px'
    }

    const rootStyle: SxProps = {
        display: 'flex',
        flexDirection: 'column'
    }

    const datesContainer: SxProps = {
        padding: '0 0',
        gridTemplateColumns: 'max-content 1fr',
        display: 'grid'     
    }

    const propertyTitle: SxProps = {
        fontWeight: '700',
        fontSize: '20px',
        margin: '0 10px 0 0' 
    }

    const toDateFormat = (date: DateTime) => {
        return date.toFormat('M/dd/yyyy')
    }

    const handleStartDateClick = () => {
        if (onRangePositionChange === undefined) {
            return
        }

        onRangePositionChange('start')
    }

    const handleEndDateClick = () => {
        if (onRangePositionChange === undefined) {
            return
        }

        onRangePositionChange('end')
    }

    return (
        <Box sx={rootStyle}>
            <Box sx={headerStyle}>

                <Box sx={datesContainer}>
                    <Box
                        sx={propertyTitle}
                        onClick={handleStartDateClick}
                    >
                        Start:
                    </Box>
                    <Box
                        onClick={handleStartDateClick}
                    >
                        {startDate ? toDateFormat(startDate) : ''}
                    </Box>
                    <Box
                        sx={propertyTitle}
                        onClick={handleEndDateClick}
                    >
                        End:
                    </Box>
                    <Box
                        onClick={handleEndDateClick}
                    >
                        {endDate ? toDateFormat(endDate) : ''}
                    </Box>
                </Box>
          
            </Box>

            <Box sx={{
                display: 'grid',
                gridTemplateColumns: 'max-content max-content',
                position: 'relative',
                gap: '60px'
            }}>
                <Box sx={{
              /*      display: 'grid',*/
                }}>
                    <Box sx={
                        {
                            display: 'flex',
                            position: 'relative',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }
                    }>
                        <IconButton
                            onClick={ onMonthDecreaseHandler }
                            sx={
                                {
                                    position: 'absolute',
                                    left: '0'
                                }
                            }
                        >
                            <ArrowBackIosNewIcon />
                        </IconButton>
                        <h2>{startPeriod?.toFormat('MMMM yyyy')}</h2>
                    </Box>
                    <Box>
                    <DateCalendar
                        //disableHighlightToday
                            //onMonthChange={ startCalendarHandleMonthChange }
                            dayOfWeekFormatter={(date: any) => {
                                return date.toFormat('ccc').substring(0, 2);
                            }}
                        sx={sxCalendar}
                        value={startPeriod}
                        loading={loading}
                        slots={{
                            calendarHeader: () => (null),
                            day: Day
                        }}
                         slotProps={{
                                day: slotProps?.day || undefined
                        }}
                        />
                    </Box>
                </Box>
                <Box>
                    <Box sx={
                        {
                            display: 'flex',
                            position: 'relative',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }
                    }>
                        <h2>{endPeriod?.toFormat('MMMM yyyy')}</h2>
                        <IconButton
                            onClick={onMonthIncreaseHandler }
                            sx={
                                {
                                    position: 'absolute',
                                    right: '0'
                                }
                            }
                        >
                            <ArrowForwardIosIcon />
                        </IconButton>
                    </Box>
                    <Box>
                        <DateCalendar
                            //disableHighlightToday
                            dayOfWeekFormatter={(date) => {
                                return date.toFormat('ccc').substring(0, 2);
                            }}
                            sx={sxCalendar}
                            loading={loading}
                            value={endPeriod}
                            slots={{
                                calendarHeader: () => (null),
                                day: Day 
                            }}
                            slotProps={
                                {                                  
                                    day: slotProps?.day || undefined
                                }
                            }
                        ></DateCalendar>
                    </Box>
                </Box>
        
                    <Backdrop
                        sx={{
                            color: '#fff',  height: '100%', position: 'absolute', width: '100%',
                             }}
                        open={loading}    
                    >
                        <CircularProgress size="6rem" color="success" />
                    </Backdrop>               
            
            </Box>
        </Box>
    )
}